// src/utils/currency.js
import { useEffect } from "react";
import { useConfig } from "../DataStore/ConfigContext";

/**
 * Custom hook: returns the currently selected currency code (e.g., "UGX", "USD").
 */
export const useCurrency = () => {
  const { currency, getPreferences  } = useConfig();
  useEffect(() => {
    getPreferences();
  }, []);
  return currency;
};


